module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst additionalClasses = []\nif(model.disabled)                                      additionalClasses.push('disabled');\nif(config.orientation === 'N')                          additionalClasses.push('orientation_N');\nif(config.showArrow && config.showArrowInline)          additionalClasses.push('inlineOpenButton');\nif(config.forceOneLine || fieldConfig.forceOneLine)                 additionalClasses.push('forceOneLine');\nif(config.forceOptionsOneLine || fieldConfig.forceOptionsOneLine)   additionalClasses.push('forceOptionsOneLine');\nconst selectedOption = model.selectedOption || {}\nlet value = selectedOption.realName\nconst valueClasses = ['value']\nif(utils.collectionSize(selectedOption.additionalClasses) > 0){\nvalueClasses.push(selectedOption.additionalClasses.join(' '))\n}\nif(!value){\nvalue = fieldConfig.fallbackValue || '&nbsp;'\n}\nlet o, option, optionClasses = []\n%><div class=\"<%- additionalClasses.join(' ') %>\" data-field-code=\"<%- model.fieldCode %>\" tabindex=\"0\">\n<div class=\"main\"><%\nif(!model.disabled){\nif(config.showCustomActionButton){\n%><button class=\"custom\" tabindex=\"-1\"><i class=\"<%- config.showCustomActionButtonIcon %>\"></i></button><%\n}\n}\n%><div class=\"<%- valueClasses.join(' ') %>\" title=\"<%= ((model.selectedOption || {}).realTitle || '') %>\">\n<%- value %>\n</div><%\nif(!model.disabled){\nif(config.showArrow && config.showArrowInline){\n%><button class=\"open inline\" tabindex=\"-1\"><i class=\"<%- config.arrowIcons.closed %>\"></i></button><%\n}\nif(config.nullAble){\n%><button class=\"unset\" tabindex=\"-1\"><i class=\"<%- config.nullAbleIcon %>\"></i></button><%\n}\nif(config.showArrow && !config.showArrowInline){\n%><button class=\"open\" tabindex=\"-1\"><i class=\"<%- config.arrowIcons.closed %>\"></i></button><%\n}\n}\n%></div><%\nif(!model.disabled){\n%>\n<div class=\"optionList\">\n<div class=\"filter\">\n<input type=\"text\" value=\"\" placeholder=\"<%- __('form.fields.autoCompleteResourcePicker.filterPlaceHolder') %>\" />\n<%\nif(config.addNewElementsAllowed){\n%><button class=\"add\" tabindex=\"-1\"><i class=\"fi fi-plus-circle\"></i></button><%\n}\n%>\n</div>\n<ul>\n<%\nfor(o in model.options || []){\noption = model.options[o];\noptionClasses = []\nif(option.selected){\noptionClasses.push('selected')\n}\nif(utils.collectionSize(option.additionalClasses) > 0){\noptionClasses.push(option.additionalClasses.join(' '))\n}\n%>\n<li data-index=\"<%= o %>\" class=\"<%= optionClasses.join(' ') %>\" title=\"<%= (option.realTitle || '') %>\">\n<%- option.realName %>\n</li>\n<%\n}\n%>\n</ul>\n</div>\n<%\n}\nif(fieldConfig.isMultiPicker){\n// tabIndex is crucial! @see MARK: AUTO_COMPLETE_BUBBLE_FOCUS\n%>\n<div class=\"bubbleContainer\" tabindex=\"<%- utils.collectionSize(model.dataJSON) > 0 ? '0' : '-1' %>\">\n<%\nfor(o in model.options || []){\noption = model.options[o];\noptionClasses = ['bubble']\nif(option.selected){\noptionClasses.push('selected')\n}\nif(utils.collectionSize(option.additionalClasses) > 0){\noptionClasses.push(option.additionalClasses.join(' '))\n}\n%>\n<div class=\"<%= optionClasses.join(' ') %>\" data-index=\"<%= o %>\" title=\"<%= (option.realTitle || '') %>\">\n<div class=\"title\"><%- option.realName %></div>\n<i class=\"removeSelection fi fi-times\"></i>\n</div>\n<%\n}\n%>\n</div>\n<%\n}\n%>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\autoComplete.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const additionalClasses = []
if(model.disabled)                                      additionalClasses.push('disabled');
if(config.orientation === 'N')                          additionalClasses.push('orientation_N');
if(config.showArrow && config.showArrowInline)          additionalClasses.push('inlineOpenButton');
if(config.forceOneLine || fieldConfig.forceOneLine)                 additionalClasses.push('forceOneLine');
if(config.forceOptionsOneLine || fieldConfig.forceOptionsOneLine)   additionalClasses.push('forceOptionsOneLine');
const selectedOption = model.selectedOption || {}
let value = selectedOption.realName
const valueClasses = ['value']
if(utils.collectionSize(selectedOption.additionalClasses) > 0){
valueClasses.push(selectedOption.additionalClasses.join(' '))
}
if(!value){
value = fieldConfig.fallbackValue || '&nbsp;'
}
let o, option, optionClasses = []

    ; __line = 19
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-code=\"")
    ; __append( model.fieldCode )
    ; __append("\" tabindex=\"0\">\n<div class=\"main\">")
    ; __line = 20
    ; 
if(!model.disabled){
if(config.showCustomActionButton){

    ; __line = 23
    ; __append("<button class=\"custom\" tabindex=\"-1\"><i class=\"")
    ; __append( config.showCustomActionButtonIcon )
    ; __append("\"></i></button>")
    ; 
}
}

    ; __line = 26
    ; __append("<div class=\"")
    ; __append( valueClasses.join(' ') )
    ; __append("\" title=\"")
    ; __append(escapeFn( ((model.selectedOption || {}).realTitle || '') ))
    ; __append("\">\n")
    ; __line = 27
    ; __append( value )
    ; __append("\n</div>")
    ; __line = 28
    ; 
if(!model.disabled){
if(config.showArrow && config.showArrowInline){

    ; __line = 31
    ; __append("<button class=\"open inline\" tabindex=\"-1\"><i class=\"")
    ; __append( config.arrowIcons.closed )
    ; __append("\"></i></button>")
    ; 
}
if(config.nullAble){

    ; __line = 34
    ; __append("<button class=\"unset\" tabindex=\"-1\"><i class=\"")
    ; __append( config.nullAbleIcon )
    ; __append("\"></i></button>")
    ; 
}
if(config.showArrow && !config.showArrowInline){

    ; __line = 37
    ; __append("<button class=\"open\" tabindex=\"-1\"><i class=\"")
    ; __append( config.arrowIcons.closed )
    ; __append("\"></i></button>")
    ; 
}
}

    ; __line = 40
    ; __append("</div>")
    ; 
if(!model.disabled){

    ; __line = 42
    ; __append("\n<div class=\"optionList\">\n<div class=\"filter\">\n<input type=\"text\" value=\"\" placeholder=\"")
    ; __line = 45
    ; __append( __('form.fields.autoCompleteResourcePicker.filterPlaceHolder') )
    ; __append("\" />\n")
    ; __line = 46
    ; 
if(config.addNewElementsAllowed){

    ; __line = 48
    ; __append("<button class=\"add\" tabindex=\"-1\"><i class=\"fi fi-plus-circle\"></i></button>")
    ; 
}

    ; __line = 50
    ; __append("\n</div>\n<ul>\n")
    ; __line = 53
    ; 
for(o in model.options || []){
option = model.options[o];
optionClasses = []
if(option.selected){
optionClasses.push('selected')
}
if(utils.collectionSize(option.additionalClasses) > 0){
optionClasses.push(option.additionalClasses.join(' '))
}

    ; __line = 63
    ; __append("\n<li data-index=\"")
    ; __line = 64
    ; __append(escapeFn( o ))
    ; __append("\" class=\"")
    ; __append(escapeFn( optionClasses.join(' ') ))
    ; __append("\" title=\"")
    ; __append(escapeFn( (option.realTitle || '') ))
    ; __append("\">\n")
    ; __line = 65
    ; __append( option.realName )
    ; __append("\n</li>\n")
    ; __line = 67
    ; 
}

    ; __line = 69
    ; __append("\n</ul>\n</div>\n")
    ; __line = 72
    ; 
}
if(fieldConfig.isMultiPicker){
// tabIndex is crucial! @see MARK: AUTO_COMPLETE_BUBBLE_FOCUS

    ; __line = 76
    ; __append("\n<div class=\"bubbleContainer\" tabindex=\"")
    ; __line = 77
    ; __append( utils.collectionSize(model.dataJSON) > 0 ? '0' : '-1' )
    ; __append("\">\n")
    ; __line = 78
    ; 
for(o in model.options || []){
option = model.options[o];
optionClasses = ['bubble']
if(option.selected){
optionClasses.push('selected')
}
if(utils.collectionSize(option.additionalClasses) > 0){
optionClasses.push(option.additionalClasses.join(' '))
}

    ; __line = 88
    ; __append("\n<div class=\"")
    ; __line = 89
    ; __append(escapeFn( optionClasses.join(' ') ))
    ; __append("\" data-index=\"")
    ; __append(escapeFn( o ))
    ; __append("\" title=\"")
    ; __append(escapeFn( (option.realTitle || '') ))
    ; __append("\">\n<div class=\"title\">")
    ; __line = 90
    ; __append( option.realName )
    ; __append("</div>\n<i class=\"removeSelection fi fi-times\"></i>\n</div>\n")
    ; __line = 93
    ; 
}

    ; __line = 95
    ; __append("\n</div>\n")
    ; __line = 97
    ; 
}

    ; __line = 99
    ; __append("\n</div>")
    ; __line = 100
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\autoComplete.ejs

}